export default {
  back: "Back",
  pageTitle: "Castrol PPF Quote",
  subtitleFlow: "Instant quote",
  loading: "Loading quote data…",
  reload: "Reload",
  loadFailed: "Failed to load data",
  completeStepFirst: "Please complete the current step first",

  steps: {
    brand: "1. Brand",
    product: "2. Product",
    parts: "3. Areas",
    quote: "4. Quote",
  },

  stepMeta: {
    brand: { title: "Brand", desc: "Model" },
    product: { title: "Product", desc: "Film series" },
    parts: { title: "Areas", desc: "Coverage" },
    quote: { title: "Quote", desc: "Reference price" },
  },

  selectBrand: "Select brand",
  selectedBrand: "Selected brand",
  changeBrand: "Change",
  modelSection: "{brand} · Model",
  searchModel: "Search model",
  modelBrowseHint: "Search or browse models for this brand",
  noModels: "No models available",
  noModelsQuery: "No models matching \"{query}\"",
  bodyTypeDetected: "Detected body type: {type}",

  selectProduct: "Select product",
  fullInstallRef: "Full-wrap reference price",

  selectParts: "Select install areas",
  selectPartsHint: "Choose body panels to wrap. Multiple selection supported.",
  partsSelected: "{count} area(s) selected",
  partsList: "Panel list",
  selectAll: "Select all",
  deselectAll: "Clear all",

  partialQuote: "Partial-wrap reference quote",
  disclaimer: "For reference only, not a contract price",
  vehicleInfo: "Vehicle details",
  brandModel: "Brand & model",
  bodyType: "Body type",
  productCode: "Product",
  installParts: "Wrapped areas",

  prev: "Back",
  next: "Next",
  viewQuote: "View quote",
  restart: "New quote",
  adjustParts: "Adjust areas",

  searchBrand: "Search brand, e.g. VW, BMW",
  brandBrowseHint: "Browse by initial letter. NEV brands supported.",
  noBrands: 'No brands found for "{query}"',

  bodyTypes: {
    轿车: "Sedan",
    SUV: "SUV",
    跑车: "Sports car",
    MPV: "MPV",
  },

  productTier: {
    flagship: "Flagship",
    premium: "Premium",
    quality: "Quality",
    bestseller: "Bestseller",
    balanced: "Balanced",
    entry: "Entry",
    default: "PPF",
  },

  productNames: {
    T9: "Timeless(T9-1501)Paint Protection Film",
    A8: "Advanced(A8-1401)Paint Protection Film",
    E7: "Enhanced(E7-1301)Paint Protection Film",
    GM7: "Gleaming(Matt)(GM7-1102)Paint Protection Film",
    GH7: "Gleaming(High Gloss Black)(GH7-1103)Paint Protection Film",
    R8: "Refined(R8-1201)Paint Protection Film",
    G7: "Gleaming(G7-1101)Paint Protection Film",
    CC: "Enhanced (CC-01-3101) Automotive Paint Film",
  },
  productCategory: {
    ppf: "PPF",
    paint: "Paint Film",
  },

  vehiclePhaseBrand: "Brand",
  vehiclePhaseModel: "Model",
  vehicleHubTitle: "Select vehicle",
  vehicleHubDesc: "Choose brand and model; body type is detected automatically",
  vehicleHubBrandEmpty: "Select a brand",
  vehicleHubModelEmpty: "Select a brand first",
  vehicleHubModelPlaceholder: "Select a model",
  vehiclePickerBack: "Back",
  vehicleFlowLabel: "Vehicle selection",
  vehicleFlowModelHint: "Choose a model",
  changeBrandHint: "Tap to change brand",
  livePrice: "Quote",
  saveScreenshot: "Save image",
  screenshotSaved: "Image saved",
  screenshotPreviewHint: "Long-press the image to save",
  screenshotPreviewTitle: "Quote image preview",
  screenshotPreviewClose: "Close preview",
  screenshotPreviewPrev: "Previous image",
  screenshotPreviewNext: "Next image",
  screenshotSegmented: "Long content split into {count} images — long-press each to save",
  screenshotFailed: "Save failed, try again",
  screenshotTimeout: "Timed out, please try again",
  capturingScreenshot: "Generating image",
  capturingScreenshotHint: "Rendering page content…",
  capturingScreenshotSlice: "Generating part {current} of {total}…",
  capturingScreenshotSaving: "Almost done, preparing preview…",
  notSelected: "Not selected",
  partSelected: "Selected",
  partsSelectedGroup: "Selected ({count})",
  partsNotSelectedGroup: "Not selected ({count})",
  allInstallParts: "Panel details",

  parts: {
    引擎盖: "Hood",
    车顶: "Roof",
    后尾箱盖: "Trunk lid",
    左后叶子板: "L rear fender",
    右后叶子板: "R rear fender",
    前左叶子板: "L front fender",
    前右叶子板: "R front fender",
    左后门: "L rear door",
    右后门: "R rear door",
    左前门: "L front door",
    右前门: "R front door",
    前杠: "Front bumper",
    后杠: "Rear bumper",
    左侧裙边: "L side skirt",
    右侧裙边: "R side skirt",
    左后视镜: "L mirror",
    右后视镜: "R mirror",
  },
};
